import React, { Component } from 'react';
import { Field, reduxForm } from 'redux-form'
import validate from './validation'
import { renderCal, renderInput, renderCheckbox }from './Fields'
import moment from 'moment'
import AddressesForm from '../AddressForm'
import _ from 'lodash'

class CasoFormStep1 extends Component{
    constructor(props) {
        super(props);
        this.state = {
            envio:  this.props.summary && this.props.summary.envio || null,
            entrega: this.props.summary && this.props.summary.entrega || null,
            warningDate: false,
            showNewAddress: false,
            selectedAddress: "address",
            showBillingAddress: false,
            changedAddress: false,
            changedBillingAddress: false,
        }
    }
    componentDidMount(){
    }
    componentDidUpdate(prevProps, prevState) {
        if(this.props !== prevProps
            && prevProps.addresses
            && prevProps.addresses.length > 0
            && _.differenceWith(this.props.addresses, prevProps.addresses, _.isEqual).length > 0
        ){
            const newAddress = _.differenceWith(this.props.addresses, prevProps.addresses, _.isEqual);
            const newAddressId = newAddress[0].id
            this.props.change(this.state.selectedAddress, newAddressId)
        }
        if(!this.props.addresses) return
        if(!this.state.changedAddress){
            this.props.change("address", _.find(this.props.addresses, 'favorite', 1) ? _.find(this.props.addresses, 'favorite', 1).id : null)
        }
    }
    renderSelect(field){
        if(!this.props.addresses){
            return false
        }
        let options = [<option key="_0" value="_0">Seleccione una dirección</option>]
        this.props.addresses.forEach((item, i) => {
            options.push(
                <option key={item.id} value={item.id}>{item.address}</option>
            )
        });
        options.push(<option key="_1" value="_1">Añadir nueva dirección</option>)
        return(
            <div className={field.col ? "form-group " + field.col : "form-group"}>
                <label>{field.label}</label>
                <select
                    className="form-control"
                    {...field.input}
                >
                    {options}
                </select>
                {field.meta.touched && field.meta.error && <span className="text-danger">{field.meta.error}</span>}
            </div>
        )
    }
    renderTextArea(field){
        return(
            <div className={field.col ? "form-group " + field.col : "form-group"}>
                <label>{field.label}</label>
                <textarea
                    className="form-control"
                    {...field.input}
                    rows="5">
                </textarea>
            </div>
        )
    }
    toggle() {
        this.setState({
            showNewAddress: !this.state.showNewAddress
        })
    }
    render(){
        const { handleSubmit, invalid} = this.props;
        return(
            <div>
                <form onSubmit={handleSubmit}>
                    <h4>Datos del caso</h4>
                    <div className="form-row">
                        <Field
                            name="nombre"
                            type="text"
                            component={renderInput}
                            label="Nombre del paciente"
                            col="col-md-4"
                        />
                        <Field
                            name="apellidos"
                            type="text"
                            component={renderInput}
                            label="Apellidos del paciente"
                            col="col-md-6"
                        />
                        <Field
                            name="phone"
                            type="text"
                            component={renderInput}
                            label="Teléfono"
                            col="col-md-2"
                        />
                        <Field
                            name="address"
                            col="col-md-4"
                            label="Dirección de envío"
                            onChange={(e)=>{
                                if(e.target.value === "_1"){
                                    this.toggle()
                                    this.setState({
                                        selectedAddress: "address"
                                    })
                                }
                                this.setState({
                                    changedAddress: true
                                })
                            }}
                            component={this.renderSelect.bind(this)}
                        />
                        {this.state.showBillingAddress || (this.props.summary && this.props.summary.billing_address) ?
                            <Field
                                name="billing_address"
                                col="col-md-4"
                                label="Dirección de facturación"
                                onChange={(e)=>{
                                    if(e.target.value === "_1"){
                                        this.toggle()
                                        this.setState({
                                            selectedAddress: "billing_address",
                                            changedBillingAddress: true
                                        })
                                    }
                                }}
                                component={this.renderSelect.bind(this)}
                            />
                            :
                            <div className="col-md-4 checkbox-address">
                                <label>Dirección de facturación</label>
                                <Field
                                name="billing_address_checker"
                                col="col-md-12"
                                label="Utilizar la misma dirección para la facturación"
                                onChange={(e)=>{
                                    this.setState({showBillingAddress: !this.state.showBillingAddress})
                                }}
                                component={renderCheckbox}
                            />
                            </div>
                        }
                        <Field
                            name="envio"
                            type="text"
                            component={renderCal}
                            label="Fecha envío al laboratorio"
                            col="col-md-2"
                            onChange={(e)=>{
                                this.setState({ envio: e })
                            }}
                        />
                        <Field
                            name="entrega"
                            type="text"
                            component={renderCal}
                            disabled={!this.state.envio}
                            label="Fecha entrega a la clínica"
                            limit={this.state.envio}
                            warnText={this.state.warningDate && "Tiempo mínimo de entrega 7 días laborables"}
                            onChange={(e)=>{
                                const daysbefore = moment(this.state.envio).add(7, 'days');
                                this.setState({warningDate: moment(e).isBefore(daysbefore)})
                            }}
                            col="col-md-2"
                        />
                        <Field
                            name="description"
                            type="text"
                            component={this.renderTextArea}
                            label="Observaciones"
                            col="col-md-12"
                        />
                    </div>
                    <div className="form-actions">
                        <button type="submit" className="btn btn-primary next float-right">Siguiente &nbsp;<i className="fa fa-chevron-right"></i></button>
                    </div>
                </form>
                <AddressesForm
                    toggler={this.toggle.bind(this)}
                    show={this.state.showNewAddress}
                    clientId={this.props.clientId}
                />
            </div>
        )
    }
}
export default reduxForm({
    form: 'wizard', //                 <------ same form name
    destroyOnUnmount: false, //        <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    initialValues: {
        billing_address_checker: true
    },
    validate,
})(CasoFormStep1);



// WEBPACK FOOTER //
// ./resources/assets/js/components/forms/newcaso/CasoFormStep1.jsx